import { render, staticRenderFns } from "./laborerPaymentDetail.vue?vue&type=template&id=46ea893f&scoped=true"
import script from "./laborerPaymentDetail.vue?vue&type=script&lang=js"
export * from "./laborerPaymentDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ea893f",
  null
  
)

export default component.exports